<template>
    <div class="section__header">
      <div class="row align-items-md-end">
        <div class="col-auto">
            <div class="section__title section__title_style1">{{ $t("personalArea") }}</div>
        </div>
        <div class="col-auto order-md-last ml-auto">
            <div class="section__date color-gray">{{currentDate}}</div>
        </div>
        <div class="col-12 col-md-auto">
            <div class="section__title section__title_style2 color-green">
                <h1><slot name="pageTitle"></slot></h1>
            </div>
        </div>
      </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
    computed:{
        ...mapGetters({
            lang: 'assistant/lang'
        }),
        currentDate: function(){
            if (this.lang === 'en'){
                return new Intl.DateTimeFormat('en-En', {day: '2-digit', month: 'long', year: 'numeric'}).format(new Date())
            }else if(this.lang === 'kz'){
                return new Intl.DateTimeFormat('kk-KZ', {day: '2-digit', month: 'long', year: 'numeric'}).format(new Date())
            }else{
                return new Intl.DateTimeFormat('ru-Ru', {day: '2-digit', month: 'long', year: 'numeric'}).format(new Date())
            }
        }
    }
}
</script>
<style>

</style>